import React from 'react'
import { createRoot } from 'react-dom/client'

import './index.css'
import App from './App'
import SentryErrorBoundary from './utils/SentryErrorBoundary'
import { getUserTokenKey } from './app/utils/browser'
import { DATA_OBJECT_KEY, OLD_USER_ID_KEY } from 'app/constants/localStorageKeys'

// Request domain info
window.parent.postMessage(
  {
    type: 'REQUEST_DOMAIN_INFO',
  },
  '*',
)

// Listen for responses
window.addEventListener('message', function (event) {
  switch (event.data.type) {
    case 'DOMAIN_INFO_RESPONSE':
      this.window.PARENT_DOM_URL = event.data.href
      break
  }
})

const SentryFallBack = ({ error }) => {
  console.error(`Raychat initialization failed.\nError: ${error.toString()}\n`)

  return null
}

/*
  We decided to change user id  key in local storage to RC#`${window.RAYCHAT_TOKEN}`
  to adding multiple widgets in different pages of a website.

  Below code, puts user id in RC#`${window.RAYCHAT_TOKEN}`.
*/

const userIdSavedByOldKey = localStorage.getItem(OLD_USER_ID_KEY)
const savedDataInLocalObject = localStorage.getItem(DATA_OBJECT_KEY)
const newUserIdLocalStorageKey = getUserTokenKey()

if (
  userIdSavedByOldKey &&
  !localStorage.getItem(newUserIdLocalStorageKey) &&
  !JSON.parse(savedDataInLocalObject)?.isTokenReplaced
) {
  const obj = savedDataInLocalObject
  const data = obj ? JSON.parse(obj) : {}
  data[newUserIdLocalStorageKey] = userIdSavedByOldKey
  // add flag
  data['isTokenReplaced'] = true
  localStorage.setItem(DATA_OBJECT_KEY, JSON.stringify(data))
  localStorage.setItem(newUserIdLocalStorageKey, userIdSavedByOldKey)
}

const root = createRoot(document.getElementById('root_raychat'))

root.render(
  <SentryErrorBoundary
    beforeCapture={(scope) => {
      scope.setTag('origin', 'raychat')
    }}
    fallback={SentryFallBack}
  >
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </SentryErrorBoundary>,
)
